import {userConsts} from '../constants/users';
import C from '../constants';


export const user = (state = {}, action) => {
    switch (action.type) {
        case 'UPDATE_SUBS': 
            return {
                ...state,
                forum: {
                    ...state.forum,
                    subscriptions: action.data, 
                }, 
            }
        case 'ADD_SUBSCRIPTION': 
            console.log('adding subscription');
            return {
                ...state,
                forum: {
                    ...state.forum,
                    subscriptions: state.forum.subscriptions.concat(action.data), /*data is {name, logo, title}*/
                },
            };
        case 'REMOVE_SUBSCRIPTION': {
            const idx = state.forum.subscriptions.findIndex(e => e.name == action.data.name);/*data is {name, logo, title}*/
            if (idx == -1) return {...state};
            return {
                ...state,
                forum: {
                    ...state.forum,
                    subscriptions: state.forum.subscriptions.slice(0, idx).concat(state.forum.subscriptions.slice(idx + 1))
                }
            };
        }
        case C.ADD_USER_TO_STORAGE:
            return {
                ...action.user,
                statusLoad: action.statusLoad,
            };
        case C.DELETE_USER_FROM_STORAGE:
            return {
                ...action.user,
                forum: {
                    subscriptions: [],
                    commends: {
                        plus: [],
                        minus: [],
                    },
                    bookmarks: [],
                },
                statusLoad: action.user.statusLoad
            };

        case C.START_LOADING_USER:
            return {
                ...action.user,
                statusLoad: action.statusLoad,
            };
        case C.FAIL_LOADING:
            return {
                ...action.user,
                statusLoad: action.statusLoad,
            };

        case userConsts.UPDATE_USER_DATA:
            return {
                ...state,
                ...action.user,
                statusLoad: action.statusLoad,
            };

        case userConsts.CHANGE_USER_PERSONAL_DATA:
            return {
                ...state,
                avatar: action.user.avatar,
                firstname: action.user.firstname,
                lastname: action.user.lastname,
                birthday: action.user.birthday,
                city: action.user.city,
                workPlace: action.user.workPlace,
                university: action.user.university,
                skills: action.user.skills,
                tgNickname: action.user.tgNickname,
                cityOther: action.user.cityOther,
                eduLevel: action.user.eduLevel,
                eduLevelOther:action.user.eduLevelOther,
                gradYear: action.user.gradYear,
                universityOther: action.user.universityOther,
                major: action.user.major,
                majorOther: action.user.majorOther,
                codingSkills: action.user.codingSkills,
                codingSkillsOther: action.user.codingSkillsOther,
                expLevel: action.user.expLevel,
                cvUrl: action.user.cvUrl
            };

        case userConsts.CHANGE_AVATAR:
            return {
                ...state,
                avatarAfterSave: action.avatar,
            };


        case userConsts.CHANGE_STATUS:
            return {
                ...state,
                status: action.status,
            };

        case userConsts.CHANGE_STATUS_NOTIFY:
            return {
                ...state,
                isNewNotify: action.status,
            };

        case userConsts.CHANGE_PHONE:
            return {
                ...state,
                phone: action.phone,
            };

        case userConsts.CHANGE_LOGIN:
            return {
                ...state,
                login: action.login,
            };

        case userConsts.CHANGE_NICKNAME:
            return {
                ...state,
                nickname: action.nickname,
            };
        case userConsts.CHANGE_EMAILSUB:
            return {
                ...state,
                emailSub: action.emailSub,
            };

        case userConsts.LEAVE_TEAM:
            let champs = [...state.champs];
            champs.splice(champs.indexOf(champs.find(champ => champ.champname === action.champname)), 1);
            return {...state, champs: champs};


        case userConsts.ADD_TEAM:
            return {...state, champs: [...state.champs, action.champ]};

        default:
            return state;
    }
};






// WEBPACK FOOTER //
// src/reducers/user.jsx